import ExamIcon from 'app/components/ExamIcon';
import { HorizontalScroller } from 'app/components/HorizontalScroller';
import RadioImage from 'app/components/RadioImage';
import { Study } from 'app/interfaces/Study';
import isWorkListImage from 'app/utils/isWorkListImage';
import React from 'react';

type PreviewImagesProps = {
  study?: Study;
};

// Here images are in fact of type RadioImageData.
// It is not trivial to change implementation so we will keep this comment for now, but we could improve things
const PreviewImages: React.FC<PreviewImagesProps> = ({ study }) => (
  <HorizontalScroller className="preview-images">
    <div className="thumbnails">
      {study?.images?.map((image) => (
        <div className="image" role="presentation" key={image._id}>
          {isWorkListImage(image) ? (
            <ExamIcon exam={image.anatomicRegion} animal={study.patient} />
          ) : (
            <RadioImage thumbnailMode image={image} />
          )}
        </div>
      ))}
    </div>
  </HorizontalScroller>
);

export default PreviewImages;
